<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import PovliLogo from '../components/PovliLogo.vue'
import { resolveLanding } from '../content/registry'
import { readAttribution } from '../lib/attribution'
import { createAppHandoffLinks } from '../lib/google-play'

const route = useRoute()
const targetLanding = String(route.params.landingId)
const experience = resolveLanding(targetLanding)
const handoff = computed(() => {
  if (!experience) return null
  const params = new URLSearchParams(window.location.search)
  return createAppHandoffLinks({
    sourceLanding: params.get('source_landing') ?? targetLanding,
    targetLanding,
    handoffId: params.get('handoff_id') ?? undefined,
    attribution: readAttribution(window.location.search),
  })
})
</script>

<template>
  <main class="grid min-h-dvh place-items-center bg-paper px-6 py-12 text-ink">
    <section class="w-full max-w-md rounded-[28px] border border-line bg-white/70 p-7 text-center shadow-[0_20px_70px_rgba(56,44,37,.10)]">
      <div class="flex justify-center"><PovliLogo /></div>
      <template v-if="experience && handoff">
        <p class="mt-8 text-xs font-bold uppercase tracking-[0.18em] text-accent">Continue the story</p>
        <h1 class="mt-3 font-serif text-3xl font-semibold">{{ experience.story.title }}</h1>
        <p class="mt-3 leading-7 text-muted">Open Povli to continue, or install it from Google Play.</p>
        <a :href="handoff.appUrl!" class="mt-7 flex min-h-12 items-center justify-center rounded-full bg-ink px-6 py-3 font-bold text-paper">Open Povli</a>
        <a :href="handoff.googlePlayUrl" class="mt-3 flex min-h-12 items-center justify-center rounded-full border border-line bg-white px-6 py-3 font-bold text-ink">Get it on Google Play</a>
      </template>
      <template v-else>
        <p class="mt-8 text-xs font-bold uppercase tracking-[0.18em] text-accent">Link unavailable</p>
        <h1 class="mt-3 font-serif text-3xl font-semibold">This continuation isn’t available.</h1>
        <RouterLink to="/" class="mt-7 inline-flex min-h-12 items-center rounded-full bg-ink px-6 py-3 font-bold text-paper">Explore Povli</RouterLink>
      </template>
    </section>
  </main>
</template>
